import React, { useState, Fragment, useEffect } from 'react';
// import DataTable from 'react-data-table-component';
import DataTable from "react-data-table-component";
import { Link, useNavigate } from 'react-router-dom';
import { Form } from 'react-bootstrap';
import { FaEye } from "react-icons/fa";
import moment from 'moment';

import Layout from '../../Layout/Layout';
import { gettokenlist } from '../../actions/users';

const TokenList = () => {


  const navigate = useNavigate();


  const [userList, setUserList] = useState([
    {
      "EmailAddress": "dummy@gmial.com",
      "Name": "maticz",
      "Subject": "summy subject",
      "Detail": "dummy detailssss",
      "NFTCategory": "dummy detailssss",
      "NFTRoyality": "dummy detailssss",
      "ListStatus": "dummy detailssss",
      "ListedQuantity": "dummy detailssss",
      "NFTQuantity": "dummy detailssss",
    },
  ]);
      const [searchText, setSearchText] = useState("");
  

  const [nft, setNFT] = useState();

  // const columns = [
  //     {
  //       key: "",
  //       name: "SNO",
  //       className: "NFT",
  //       align: "left",
  //       sortable: true,
  //       selector: (record, index) =>
  //         <div>{index + 1}
  //         </div>

  //     },
  //     {
  //         id:1,
  //     //   key: "Email",
  //       name: "NFTId",
  //       className: "NFT",
  //     //   align: "left",
  //       selector: rec =>
  //         <div title={rec.EmailAddress}>{rec?.EmailAddress}</div>
  //     },
  //     {
  //         id:2,
  //     //   key: "UserName",
  //       name: "NFT Name",
  //       selector: rec => <div>{rec?.Name}</div>,
  //       className: "NFT",
  //     //   align: "left",
  //     //   selector: rec =>
  //     //     <div title={rec.FirstName}>{(rec?.UserId?.UserName?.length > 13 ? rec?.UserId?.UserName.toString().slice(0, 5) + '...' + rec?.UserId?.UserName.toString().slice(-5) : rec?.UserId?.UserName)}</div>
  //     },
  //     {
  //         id:3,
  //     //   key: "Subject",
  //       name: "NFT Creator",
  //       selector:rec => <div>{rec?.Subject}</div>
  //     //   className: "NFT",
  //     //   align: "left",
  //     //   selector: rec =>
  //     //     <div title={rec.Subject}>{(rec?.Subject?.length > 13 ? rec?.Subject.toString().slice(0, 5) + '...' + rec?.Subject.toString().slice(-5) : rec?.Subject)}</div>
  //     },


  //     {
  //         id:4,
  //       name: "NFT Owner",
  //       selector:rec => <div>{rec?.Detail}</div>
  //     //   selector: record =>
  //     //     <div><Link to={{ pathname: `/supportticketdetail` }} state={record} ><button className=' allbtn'>view</button></Link></div>

  //     },
  //     {
  //         id:5,
  //       name: "NFT Category",
  //       selector:rec => <div>{rec?.NFTCategory}</div>
  //     //   selector: record =>
  //     //     <div><Link to={{ pathname: `/supportticketdetail` }} state={record} ><button className=' allbtn'>view</button></Link></div>

  //     },
  //     {
  //         id:6,
  //       name: "NFT Royality (in Percentage)",
  //       selector:rec => <div>{rec?.NFTRoyality}</div>
  //     //   selector: record =>
  //     //     <div><Link to={{ pathname: `/supportticketdetail` }} state={record} ><button className=' allbtn'>view</button></Link></div>

  //     },
  //     {
  //         id:7,
  //       name: "List Status",
  //       selector:rec => <div>{rec?.ListStatus}</div>
  //     //   selector: record =>
  //     //     <div><Link to={{ pathname: `/supportticketdetail` }} state={record} ><button className=' allbtn'>view</button></Link></div>

  //     },
  //     {
  //         id:8,
  //       name: "Listed Quantity",
  //       selector:rec => <div>{rec?.ListedQuantity}</div>
  //     //   selector: record =>
  //     //     <div><Link to={{ pathname: `/supportticketdetail` }} state={record} ><button className=' allbtn'>view</button></Link></div>

  //     },
  //     {
  //         id:9,
  //       name: "NFT Quantity",
  //       selector:rec => <div>{rec?.NFTQuantity}</div>
  //     //   selector: record =>
  //     //     <div><Link to={{ pathname: `/supportticketdetail` }} state={record} ><button className=' allbtn'>view</button></Link></div>

  //     },
  //     {
  //         id:10,
  //       name: "NFT Available Quantity(balance)",
  //       selector:rec => <div>{rec?.NFTQuantity}</div>
  //     //   selector: record =>
  //     //     <div><Link to={{ pathname: `/supportticketdetail` }} state={record} ><button className=' allbtn'>view</button></Link></div>

  //     },
  //     {
  //         id:11,
  //       name: "NFT Price",
  //       selector:rec => <div>{rec?.NFTQuantity}</div>
  //     //   selector: record =>
  //     //     <div><Link to={{ pathname: `/supportticketdetail` }} state={record} ><button className=' allbtn'>view</button></Link></div>

  //     },
  //     {
  //         id:12,
  //       name: "Start Clock Time",
  //       selector:rec => <div>{rec?.NFTQuantity}</div>
  //     //   selector: record =>
  //     //     <div><Link to={{ pathname: `/supportticketdetail` }} state={record} ><button className=' allbtn'>view</button></Link></div>

  //     },
  //     {
  //         id:13,
  //       name: "End Clock Time",
  //       selector:rec => <div>{rec?.NFTQuantity}</div>
  //     //   selector: record =>
  //     //     <div><Link to={{ pathname: `/supportticketdetail` }} state={record} ><button className=' allbtn'>view</button></Link></div>

  //     },
  //     {
  //         id:14,
  //       name: "Minimum Bid For Timed Auction",
  //       selector:rec => <div>{rec?.NFTQuantity}</div>
  //     //   selector: record =>
  //     //     <div><Link to={{ pathname: `/supportticketdetail` }} state={record} ><button className=' allbtn'>view</button></Link></div>

  //     },
  //     {
  //         id:15,
  //       name: "SelectedNetwork",
  //       selector:rec => <div>{rec?.NFTQuantity}</div>
  //     //   selector: record =>
  //     //     <div><Link to={{ pathname: `/supportticketdetail` }} state={record} ><button className=' allbtn'>view</button></Link></div>

  //     },

  //   ]

  const columns = [
    {
      key: "ind",
      name: "S.no.",
      className: "name",
      align: "left",
      sortable: false,
      cell: (row, index, column, id) =>
        <p>{index + 1}</p>

    },
    {

      key: "tokenCounts",
      name: "NFT Id",
      className: "tokenId",
      align: "left",
      sortable: false,
      cell: (row, index, column, id) =>(
        <p>{row?.tokenCounts}</p>
      ),

    },
    {
      key: "tokenName",
      name: "NFT Name",
      className: "Name",
      align: "left",
      sortable: false,
      cell: (row, index, column, id) =>(
        <p>{row?.tokenName}</p>
      ),
    },
    {

      key: "tokenCreator",
      name: "NFT Creator",
      className: "tokenCreator",
      align: "left",
      sortable: false,
      cell: (row, index, column, id) =>(
        <p>{row?.tokenCreator}</p>
      ),

    },
    {

      key: "tokenOwner",
      name: "NFT Owner",
      className: "tokenOwner",
      align: "left",
      sortable: false,
      cell: (row, index, column, id) =>(
        <p>{String(row.tokenOwnerDb.tokenOwner)}</p>
      ),


    },
    {

      key: "tokenCategory",
      name: "NFT Category",
      className: "tokenCategory",
      align: "left",
      sortable: false,
      cell: (row, index, column, id) =>(
        <p>{row.tokenRoyality}</p>
      ),
    },
    {

      key: "tokenRoyality",
      name: "NFT Royalty (in Percentage)",
      className: "tokenRoyality",
      align: "left",
      sortable: false,
      cell: (row, index, column, id) =>(
        <p>{row?.tokenRoyality}</p>
      ),
    },
    {

      key: "ListNFT",
      name: "List Status",
      className: "tokenBid",
      align: "left",
      sortable: false,
      cell: val =>
        <div>{String(val?.ListNFT)}</div>

    },
    {

      key: "ListedQuantity",
      name: "Listed Quantity",
      className: "tokenBid",
      align: "left",
      sortable: false,
      cell: val =>
        <div>{Number(val.ListedQuantity)}</div>

    },
    {

      key: "tokenQuantity",
      name: "NFT Quantity",
      className: "tokenQuantity",
      align: "left",
      sortable: false,
      cell: (row, index, column, id) =>(
        <p>{row?.tokenQuantity}</p>
      ),
    },

    {

      key: "NFTBalance",
      name: "NFT Available Quantity(balance)",
      className: "balance",
      align: "left",
      sortable: false,
      cell: (row, index, column, id) =>(
        <p>{String(row.tokenOwnerDb.balance)}</p>
      ),


    },

    {

      key: "tokenPrice",
      name: "NFT Price",
      className: "tokenPrice",
      align: "left",
      sortable: false,
      cell: (row, index, column, id) =>(
        <p>{String(row.tokenOwnerDb.tokenPrice)}</p>
      ),


    },
    {

      key: "clocktime",
      name: "Start Clock Time",
      className: "tokenPrice",
      align: "left",
      sortable: false,
      cell: (row, index, column, id) =>(
        <p>{row.clocktime!=null?moment(row.clocktime).format('MMMM,Do YYYY, hh:mm A'):"null"}</p>
      ),


    },
    {

      key: "endclocktime",
      name: "End Clock Time",
      className: "tokenPrice",
      align: "left",
      sortable: false,
      cell: (row, index, column, id) =>(
        <p>{row.endclocktime!=null?moment(row.endclocktime).format('MMMM,Do YYYY, hh:mm A'):"null"}</p>
      ),


    },
    {

      key: "minimumBid",
      name: "Minimum Bid For Timed Auction",
      className: "minimumBid",
      align: "left",
      sortable: false,
      cell: record =>
        // <div>{record.clocktime}</div>
        <div><p>{record.minimumBid}</p></div>


    },
    {

      key: "SelectedNetwork",
      name: "SelectedNetwork",
      className: "SelectedNetwork",
      align: "left",
      sortable: false,
      cell: record =>

        <div><p>{(record.SelectedNetwork == '43113') ? 'AVAX' : 'BSC'}</p></div>

    },
    {

      key: "ipfsimage",
      name: "Image Hash Value",
      className: "image",
      align: "left",
      sortable: false,
      cell: (row, index, column, id) =>(
        <p>{row?.ipfsimage}</p>
      ),
    },

    {
      key: "timestamp",
      name: "Created At",
      className: "Date",
      align: "left",
      sortable: false,
      cell: (row, index, column, id) =>(
        <p>{moment(row.timestamp).format('MMMM,Do YYYY, hh:mm A')}</p>
      ),
    },
    {
      key: "deleted",
      name: "Hide/Show",
      className: "Date",
      align: "left",
      sortable: false,
      cell: (row, index, column, id) =>(
        <p>{(row.tokenOwnerDb.deleted==1)? "Visible" :"Hidden"}</p>
      ),
    },

    {
      key: "action",
      name: "Actions",
      className: "action",
      width: 200,
      align: "left",
      sortable: false,
      cell: record => {
        return (
          <Fragment>
            <button
              data-toggle="modal"
              data-target="#update-template-modal"
              className="btn btn-primary btn-sm"
              // onClick={() => navigate("/viewToken")}
                onClick={() => ViewTokens(record)}

              style={{ marginRight: '5px' }}
            >
              {/* <i className="fa fa-edit"></i> */}
              {/* <i className="fa fa-eye"></i> */}
              <FaEye />
            </button>
          </Fragment>
        );
      }
    },
  ];

  useEffect(() => {
    getTokenlist();
  }, [searchText])

  const getTokenlist = async () => {
    var test = await gettokenlist({searchText});
    
    setNFT(test.userValue);
  }

  const ViewTokens = async (record) => {
    // alert("1")
    
    if (record.tokenOwnerDb && record.tokenOwnerDb.tokenCounts && record.tokenOwnerDb.tokenOwner) {
      navigate("/ViewToken/" + record.tokenOwnerDb.tokenOwner + "/" + record.tokenOwnerDb.tokenCounts);
    }
    else {
      navigate("/ViewToken/" + record.tokenOwner + "/" + record.tokenCounts);

    }
  }

  return (
    <Layout>
      <div className="tokenlist">
        <h1 className="pagehead">NFT List</h1>
        <div className="cardbox">
          <div className="tablebox">
            <Form.Control type="text" onChange={(e)=>setSearchText(e?.target?.value)} value={searchText} placeholder="NFT name or NFT Id" />
            <DataTable
              className='react-datatables'
              columns={columns}
              data={nft}
              pagination // Enable pagination
              // paginationPerPage={2} // Rows per page
              paginationRowsPerPageOptions={[5, 10, 15, 20]}
            />
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default TokenList;